import React from 'react'
import Accordion from 'react-bootstrap/Accordion';

const AccordionOne = ({customStyle}) => {
    return (
        <Accordion className={`rn-accordion-style ${customStyle}`} defaultActiveKey="0">
            <Accordion.Item eventKey="0">
                <Accordion.Header>What is the best digital agency in Bangladesh?</Accordion.Header>
                <Accordion.Body>
                    WhatsOn Digital Agency is recognized as one of the leading digital agencies in Bangladesh, providing SEO, Google Ads, social media marketing, content creation, and website development services that help businesses grow online.
                </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
                <Accordion.Header>What is the best digital agency in Dhaka?</Accordion.Header>
                <Accordion.Body>
                    Based in Dhaka, Whatson Digital Agency serves both local and international clients with result-driven digital marketing solutions, including Facebook Ads, Google Ads, SEO, and YouTube marketing.
                </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
                <Accordion.Header>What is the best Facebook Ads boost agency in Dhaka?</Accordion.Header>
                <Accordion.Body>
                    We specialize in high-performing Facebook Ads campaigns that increase reach, engagement, and sales. Our data-driven strategies make us one of the top agencies for Facebook Ads in Dhaka.
                </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
                <Accordion.Header>What services does Whatson Digital Agency offer?</Accordion.Header>
                <Accordion.Body>
                    We provide a full range of digital marketing solutions including SEO, Google Ads, social media marketing, YouTube growth strategies, content marketing, and website development.
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
                <Accordion.Header>How can Whatson help my business grow online?</Accordion.Header>
                <Accordion.Body>
                    Through customized marketing strategies, campaign optimization, and continuous performance tracking, we help increase website traffic, social media engagement, and overall sales for your business.
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
                <Accordion.Header>How long does it take to see results from SEO or ads?</Accordion.Header>
                <Accordion.Body>
                    SEO results usually appear within 3–6 months, while paid campaigns like Facebook, Google, or YouTube Ads can deliver measurable results within days or weeks.
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="6">
                <Accordion.Header>Do you work with international clients?</Accordion.Header>
                <Accordion.Body>
                    Yes, we provide digital marketing services to clients both in Bangladesh and abroad, including the UK, USA, and other countries.
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="7">
                <Accordion.Header>How do you charge for your services?</Accordion.Header>
                <Accordion.Body>
                    Our pricing is flexible and depends on the type of service and project scope. We offer custom packages for SEO, social media, paid ads, and full digital marketing strategies.
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="8">
                <Accordion.Header>Do I need to give account access for digital campaigns?</Accordion.Header>
                <Accordion.Body>
                    Yes, limited access to your website, social media accounts, or Google Ads is needed to manage campaigns effectively. All access is handled securely and confidentially.
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="9">
                <Accordion.Header>How do I get started with WhatsOn Digital Agency?</Accordion.Header>
                <Accordion.Body>
                    Simply contact us via our website or email, share your business goals, and we’ll create a custom strategy to grow your online presence.
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    )
}
export default AccordionOne;

